import axios from "axios";
import config from "../config";
import { getAlertCounts } from "../pages/alerts/AlertsApis";

const safeArray = (value) => (Array.isArray(value) ? value : []);

const metricCatalog = {
  vehicles: { sourceId: "fleetVehicles" },
  activeVehicles: { sourceId: "fleetVehicles" },
  inactiveVehicles: { sourceId: "fleetVehicles" },
  routes: { sourceId: "fleetRoutes" },
  stops: { sourceId: "fleetStops" },
  drivers: { sourceId: "fleetDrivers" },
  sites: { sourceId: "fleetSites" },
  totalAlerts: { sourceId: "fleetAlerts" },
  vehicleAlerts: { sourceId: "fleetAlerts" },
  userAlerts: { sourceId: "fleetAlerts" },
  expiryAlerts: { sourceId: "fleetAlerts" },
  totalStudents: { sourceId: "schoolStudents" },
  totalDrivers: { sourceId: "schoolDrivers" },
  totalAttendants: { sourceId: "schoolAttendants" },
  totalVehicles: { sourceId: "schoolVehicles" },
  totalStops: { sourceId: "schoolStops" },
  totalRoutes: { sourceId: "schoolRoutes" },
};

const sourceLoaders = {
  fleetVehicles: async () => {
    const resp = await axios.get(`${config.baseURL}/vehicle/organization`, {
      withCredentials: true,
    });
    const vehicles = safeArray(resp.data);
    return {
      vehicles: vehicles.length,
      activeVehicles: vehicles.filter((vehicle) => vehicle.status === "ACTIVE").length,
      inactiveVehicles: vehicles.filter(
        (vehicle) => vehicle.status === "INACTIVE" || vehicle.status === "DEAD" || !vehicle.status,
      ).length,
    };
  },
  fleetRoutes: async () => {
    const resp = await axios.get(`${config.baseURL}/route/organization`, {
      withCredentials: true,
    });
    return { routes: safeArray(resp.data).length };
  },
  fleetStops: async () => {
    const resp = await axios.get(`${config.baseURL}/stop/organization`, {
      withCredentials: true,
    });
    return { stops: safeArray(resp.data).length };
  },
  fleetDrivers: async ({ organizationId }) => {
    const resp = await axios.get(
      `${config.baseURL}/driver/organization?organizationId=${organizationId}`,
      { withCredentials: true },
    );
    return { drivers: safeArray(resp.data).length };
  },
  fleetSites: async ({ organizationId }) => {
    const resp = await axios.get(`${config.baseURL}/site/organization?organizationId=${organizationId}`, {
      withCredentials: true,
    });
    return { sites: safeArray(resp.data).length };
  },
  fleetAlerts: async () => {
    const alertCounts = await getAlertCounts();
    return {
      totalAlerts: alertCounts?.total || 0,
      vehicleAlerts: alertCounts?.byType?.VEHICLE || 0,
      userAlerts: alertCounts?.byType?.USER || 0,
      expiryAlerts: alertCounts?.byType?.EXPIRY || 0,
    };
  },
  schoolStudents: async ({ organizationId }) => {
    const resp = await axios.get(`${config.baseURL}/student/organization`, {
      params: { organizationId },
      withCredentials: true,
    });
    return { totalStudents: safeArray(resp.data).length };
  },
  schoolDrivers: async ({ organizationId }) => {
    const resp = await axios.get(`${config.baseURL}/driver/organization`, {
      params: { organizationId },
      withCredentials: true,
    });
    return { totalDrivers: safeArray(resp.data).length };
  },
  schoolAttendants: async ({ organizationId }) => {
    const resp = await axios.get(`${config.baseURL}/employee/organization`, {
      params: { organizationId },
      withCredentials: true,
    });
    return { totalAttendants: safeArray(resp.data).length };
  },
  schoolVehicles: async () => {
    const resp = await axios.get(`${config.baseURL}/vehicle/organization`, {
      withCredentials: true,
    });
    return { totalVehicles: safeArray(resp.data).length };
  },
  schoolStops: async () => {
    const resp = await axios.get(`${config.baseURL}/stop/organization`, {
      withCredentials: true,
    });
    return { totalStops: safeArray(resp.data).length };
  },
  schoolRoutes: async ({ organizationId }) => {
    const resp = await axios.get(`${config.baseURL}/route/organization`, {
      params: { organizationId },
      withCredentials: true,
    });
    return { totalRoutes: safeArray(resp.data).length };
  },
};

export function getMetricDefinition(metricKey) {
  return metricCatalog[metricKey] || null;
}

export function getSourceLoader(sourceId) {
  return sourceLoaders[sourceId] || null;
}

export function getUniqueSourceIds(metricKeys = []) {
  const sourceIds = new Set();
  metricKeys.forEach((metricKey) => {
    const def = getMetricDefinition(metricKey);
    if (def?.sourceId) {
      sourceIds.add(def.sourceId);
    }
  });
  return [...sourceIds];
}
